/**
 * SEO Sprint 2 — Destination page: Suriname (/shipping-to-suriname).
 * CMS-driven via `destination_page_settings` slug=suriname.
 */
import React from "react";
import DestinationPage from "../components/DestinationPage";

const SURINAME_FALLBACK = {
  display_name: "Suriname",
  country_code: "SR",
  url_path: "/shipping-to-suriname",
  page_banner: {
    eyebrow: "Bestemming: Suriname",
    title: "Verzenden naar",
    highlight: "Suriname",
    subtitle:
      "Stuur uw zending van Nederland naar Suriname via zee- of luchtvracht. Persoonlijke begeleiding, documenten op orde en lokale aflevering — geregeld door één team.",
    badges: [
      { icon: "ship",    label: "Zee- en luchtvracht" },
      { icon: "package", label: "Pakketten t/m cargo" },
      { icon: "support", label: "Persoonlijke begeleiding" },
    ],
    cta_primary_label: "Vraag offerte aan",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Bel ons",
    cta_secondary_url: "tel:+31488235999",
  },
  intro: {
    eyebrow: "Over verzendingen naar Suriname",
    title: "Hoe wij uw zending naar Suriname regelen",
    body:
      "Onze zendingen naar Suriname bedienen particulieren en bedrijven die regelmatig of incidenteel goederen naar Paramaribo en omgeving sturen. Zee- en luchtvracht zijn beide beschikbaar; de juiste keuze hangt af van het type goederen, het volume en uw doorlooptijd. Wij verzorgen documenten, pickup en de coördinatie tot aan lokale aflevering.\n\nBeschikbaarheid, tarieven en procedures kunnen per bestemming en type zending verschillen. Vraag actuele routebeschikbaarheid aan — onze medewerkers helpen u graag met de juiste verzendoptie.",
  },
  service_blocks: { items: [] },
  faq: { items: [] },
  cta_band: {
    title: "Klaar om naar Suriname te verzenden?",
    description:
      "Vraag een vrijblijvende offerte aan met uw zendingdetails — wij adviseren binnen 1 werkdag de juiste route, kosten en documenten.",
    cta_primary_label: "Vraag offerte aan",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Bel ons",
    cta_secondary_url: "tel:+31488235999",
  },
  seo: {
    title: "Pakket naar Suriname sturen | Zee- en luchtvracht | 5999Cargo",
    description:
      "Stuur pakketten of cargo van Nederland naar Suriname. Zee- en luchtvracht, pickup, documenten en aflevering — geregeld door één team.",
    keywords:
      "pakket naar Suriname sturen, zeevracht Suriname, luchtvracht Suriname, vracht naar Suriname, shipping to Suriname from Netherlands",
  },
};

export default function ShippingToSurinamePage() {
  return <DestinationPage slug="suriname" fallback={SURINAME_FALLBACK} />;
}
